import _identity from 'lodash/identity';
import _isEmpty from 'lodash/isEmpty';
import _keyBy from 'lodash/keyBy';

export const SCHEDULE_LIST_FILTER_OPTIONS = [
  {
    key: 'ALL_CLASSES',
    filterMethod: _identity,
  },
  {
    key: 'CLASSES_WITH_RESERVATIONS',
    filterMethod: schedules =>
      schedules.filter(({ spots }) => {
        const { classpassBooked } = spots;
        return classpassBooked;
      }),
  },
  {
    key: 'RECOMMENDATIONS',
    filterMethod: schedules => schedules.filter(({ opportunity }) => !_isEmpty(opportunity)),
  },
  {
    key: 'DISABLED',
    filterMethod: schedules => schedules.filter(({ isDisabled }) => isDisabled),
  },
];

export const SCHEDULE_LIST_FILTER = SCHEDULE_LIST_FILTER_OPTIONS.reduce((acc, { key }) => ({ ...acc, [key]: key }), {});

export const SCHEDULE_LIST_FILTER_OPTIONS_BY_KEY = _keyBy(SCHEDULE_LIST_FILTER_OPTIONS, 'key');

export const SCHEDULE_LIST_FILTER_OPTION_KEYS = Object.keys(SCHEDULE_LIST_FILTER_OPTIONS_BY_KEY);

export const DEFAULT_SCHEDULE_LIST_FILTER = SCHEDULE_LIST_FILTER_OPTIONS[0].key;

export function filterSchedules(schedules = [], filter = DEFAULT_SCHEDULE_LIST_FILTER) {
  const { filterMethod } = SCHEDULE_LIST_FILTER_OPTIONS_BY_KEY[filter];
  return filterMethod(schedules);
}
